module.exports = __webpack_public_path__ + "zvetseni-prsou_33_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_33_before.jpg
// module id = 1328
// module chunks = 0